export const IMAGE_WIDTH = 212;
export const IMAGE_HEIGHT = 212;

export const getImageStyle = (imageCellWidth, imageCellHeight) => (components, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' } = {}) => {
  const imageContainer = {
    width: imageCellWidth,
    height: imageCellHeight,
    marginBottom: 16,
    marginRight: 16,
    position: 'relative',
    float: 'left',
    '&:hover': {
      cursor: 'pointer',
    },
  };
  const imageContainerWithMultiSelect = {
    ...imageContainer,
    padding: 2,
    marginBottom: 12,
    marginRight: 12,
  };

  return {
    imageContainer,
    imageContainerWithMultiSelect,
    image: {
      borderRadius: 6,
      filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
    },
    selectedIcon: {
      fontFamily: iconFontFamily,
      position: 'absolute',
      height: 18,
      width: 18,
      top: 9,
      left: imageCellWidth - 27,
      background: palette.themePrimary,
      borderRadius: '50%',
      border: `2px solid ${palette.white}`,
      fontSize: 10,
      color: palette.white,
      fontWeight: 'bold',
      textAlign: 'center',
      '&:before': {
        content: '"\\E73E"',
      },
    },
    cellSelectionDecoratorWrapper: {
      '& .selected-checkbox': {
        position: 'absolute',
        top: 6,
        right: 22,
        display: 'none',
      },
      '&:hover .selected-checkbox': {
        display: 'block',
      },
    },
    cellSelectionDecorator: {
      padding: 2,
    },
    selectedStateWrapper: {
      '& .selected-checkbox': {
        display: 'block',
      },
    },
    selectedState: {
      outline: 'none',
    },
    itemContainer: {
      position: 'relative',
      float: 'left',
    },
    selectedImageContainer: {
      ...imageContainer,
      border: `2px solid ${palette.themePrimary}`,
      borderRadius: 4,
    },
    selectedImageContainerWithMultiSelect: {
      ...imageContainerWithMultiSelect,
      outline: `2px solid ${palette.themePrimary}`,
      borderRadius: 6,
    },
  };
};

export const getListStyle = () => ({
  listContainer: {
    overflowY: 'auto',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
  },
  emptyListContainer: {},
});
